import { gql } from 'apollo-angular';

// ─── Superadmin only — no UI in this branch, stubbed for future use ──────────

export const CREATE_CREDIT_WALLET = gql`
  mutation ($input: CreateCreditWalletInput!) {
    createCreditWallet(input: $input) {
      id
      tenantId
      plan
      initialPlanCredits
      planCredits
      planCreditsExpireAt
      purchasedCredits
      overConsumptionCredits
    }
  }
`;

export const PURCHASE_CREDITS = gql`
  mutation ($input: PurchaseCreditsInput!) {
    purchaseCredits(input: $input) {
      id
      tenantId
      plan
      initialPlanCredits
      planCredits
      planCreditsExpireAt
      purchasedCredits
      overConsumptionCredits
    }
  }
`;
